// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-body{display:flex;justify-content:center;align-items:center;width:350px;height:44px;border-radius:6px}.fa-ban,.fa-check-circle{padding-top:3px;color:#fff}", ""]);
// Exports
module.exports = exports;
